import Vue from 'vue'
import Router from 'vue-router'
import LoginView from '@/views/LoginView.vue'
import HomeView from '@/views/HomeView.vue'
import WordSearch from '@/components/WordSearch.vue'
import WordBook from '@/components/WordBook.vue'
import NotesPage from '@/components/NotesPage.vue'
import DiaryPage from '@/components/DiaryPage.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'LoginView',
      component: LoginView
    },
    {
      path: '/home',
      name: 'Home',
      component: HomeView,
      redirect: '/home/search', // 默认跳转到单词查询
      meta: { requiresAuth: true },
      children: [
        {
          path: 'search',
          name: 'WordSearch',
          component: WordSearch
        },
        {
          path: 'book',
          name: 'WordBook',
          component: WordBook
        },
        {
          path: 'notes',
          name: 'NotesPage',
          component: NotesPage
        },
        {
          path: 'diary',
          name: 'DiaryPage',
          component: DiaryPage
        }
      ]
    }
  ]
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('token')
  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    next({ path: '/login' })
  } else {
    next()
  }
})

export default router
